export default "__VITE_ASSET__988f7a23__"